
module dgUtils {

    export interface IDgFormatPercentFilter extends Function {
        (number: number): string;
    }

    function dgFormatPercent($filter: dgUtils.IFilterService): IDgFormatPercentFilter {
        return (number) => {
            var calcPercent = number * 100;
            return $filter('number')(calcPercent, 2) + '%';
        }
    }
    dgFormatPercent.$inject = [
        '$filter'
    ];
    angular.module('dgUtils')
        .filter('dgFormatPercent', dgFormatPercent);
}